import { MissingDonorField } from '../generated/enums.gen';

// Render-boundary translation for each field (no raw enum token reaches the UI).
const MISSING_DONOR_FIELD_LABEL: Record<MissingDonorField, string> = {
  Name: 'name',
  Occupation: 'occupation',
  Employer: 'employer',
  Address: 'address',
  EmployerAddress: 'employer address',
  VagueOccupation: 'more specific occupation',
};

/**
 * AFU-001 — translate a missing-fields set to plain treasurer copy
 * (`feedback_treasurer_first_copy`): `['Occupation']` → "occupation",
 * `['Occupation','Employer']` → "occupation & employer",
 * `['Occupation','Employer','Address']` → "occupation, employer & address".
 * Replaces the inline `missing === 'both' ? … : missing` ternary, which could
 * translate `'both'` but not the new Address subset.
 */
export function missingFieldsLabel(fields: MissingDonorField[]): string {
  const parts = fields.map((f) => MISSING_DONOR_FIELD_LABEL[f]);
  if (parts.length <= 1) return parts[0] ?? '';
  if (parts.length === 2) return `${parts[0]} & ${parts[1]}`;
  return `${parts.slice(0, -1).join(', ')} & ${parts[parts.length - 1]}`;
}
